import React, { memo, useMemo } from 'react'
import tw from 'twin.macro'
import { CustomersMajor, PauseCircleMajor } from '@shopify/polaris-icons'
import { useSelector } from 'react-redux'
import { ContractorState } from 'src/constants/contractor/enums'
import { getContractorsCounts } from 'src/selectors/contractor'
import { addS } from 'src/utils/baseUtils'
import { colors } from 'src/theme'
import { TableTab, TableTabs } from 'src/components/shared/table/table-tabs/TableTabs'
import { GSIcon } from 'src/components/shared/GSIcon'

interface Props {
  selectedTab: ContractorState
  onClick(tab: ContractorState): void
}

const ContractorTabsComponent = ({ selectedTab, onClick }: Props) => {
  const contractorCounts = useSelector(getContractorsCounts)

  const tabs = useMemo(() => {
    const res: TableTab<ContractorState>[] = [
      {
        value: ContractorState.Active,
        title: 'Active',
        renderIcon: (selected: boolean) => (
          <CustomersMajor
            width={20}
            fill={selected ? colors.PRIMARY_PURPLE_600 : colors.GRAY_BLACK}
          />
        ),
      },
      {
        value: ContractorState.Deactivated,
        title: 'Deactivated',
        renderIcon: (selected: boolean) => (
          <PauseCircleMajor
            width={20}
            fill={selected ? colors.PRIMARY_PURPLE_600 : colors.GRAY_BLACK}
          />
        ),
      },
      {
        value: ContractorState.Recollection,
        title: 'Needs Review',
        renderIcon: (selected: boolean) => (
          <GSIcon
            iconName={selected ? 'gs_recollect_purple' : 'gs_recollect'}
            css={tw`self-center`}
            width={20}
            height={20}
          />
        ),
      },
    ]

    return res.map((item) => ({
      ...item,
      dataTestId: `contractors-list-tab-${item.value}`,
      subtitle: contractorCounts
        ? `${contractorCounts[item.value] || 0} ${addS(contractorCounts[item.value], 'contractor')}`
        : '',
    }))
  }, [contractorCounts])

  return <TableTabs tabs={tabs} selectedValue={selectedTab} onClick={onClick} />
}

export const ContractorTabs = memo(ContractorTabsComponent)
